import { UseFormReturn } from 'react-hook-form'
import { CorrectionField } from '~/shared/api'
import { DADATA_FMS_UNIT_URL } from '~/shared/config/constants'
import { DatePicker, TextInput, DaDataInput } from '~/shared/ui/form'
import {
  isDateField,
  isDaDataField,
  isFmsField,
  getDatePickerMaxDate,
} from '../helpers'
import { FormValues } from '../model'

type FieldInputProps = {
  field: CorrectionField
  form: UseFormReturn<FormValues>
  enableDaData: boolean
}

export const FieldInput = ({ field, form, enableDaData }: FieldInputProps) => {
  const fieldKey = field.fieldName

  if (isDateField(field.fieldName)) {
    const maxDate = getDatePickerMaxDate(field.fieldName)
    return (
      <DatePicker
        name={fieldKey}
        label={field.label}
        {...(maxDate ? { ionDatetimeProps: { max: maxDate } } : {})}
      />
    )
  }

  const isDaData = isDaDataField(field.fieldName)
  const isFms = isFmsField(field.fieldName)

  if (isDaData && enableDaData && isFms) {
    return (
      <DaDataInput<{ code: string }>
        name={fieldKey}
        label={field.label}
        url={DADATA_FMS_UNIT_URL}
        renderOption={(suggestion) =>
          `${suggestion?.data?.code} - ${suggestion?.unrestricted_value}`
        }
        onMappedSelectedValue={(suggestion) =>
          fieldKey === 'divisionCode'
            ? suggestion?.data?.code
            : suggestion?.value
        }
        {...(fieldKey === 'divisionCode'
          ? {
              onSelected: (suggestion) => {
                form.setValue('passportIssued', suggestion?.value || '')
              },
            }
          : {})}
      />
    )
  }

  if (isDaData && enableDaData) {
    return <DaDataInput name={fieldKey} label={field.label} />
  }

  return <TextInput name={fieldKey} label={field.label} />
}
